/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const frCARequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Demande d’ajout d’école',
    description: 'Veuillez remplir le formulaire ci-dessous. Les écoles dont la candidature est soumise ne sont pas garanties d’être ajoutées, mais toutes les demandes sont étudiées et prises en considération par SheerID. ',
    noCountry: 'Vous ne voyez pas le pays de votre école ? Vous n’êtes pas admissible à cette offre',
    searchByOrgName: 'Vous ne voyez pas votre école ? Rechercher par nom',
    completeRequest: 'Vous ne voyez pas votre école dans la liste des écoles admissibles ou non admissibles ? Compléter votre demande',
    submit: 'Soumettre',
    eligibleOrgs: 'Écoles admissibles. Cliquez sur l’icône pour copier le nom, puis retournez au formulaire de vérification.',
    ineligibleOrgs: 'Écoles non admissibles. Nous sommes désolés, les étudiants de ces écoles ne sont pas admissibles pour cette offre.',
    none: 'Aucune',
    country: 'Quelle école fréquentez-vous ?',
    changeLanguage: 'Changer de langue',
    copied: 'Copié',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    emailAddress: 'Adresse de courriel',
    poweredBy: 'Services de vérification effectués par SheerID',
    fields: {
        countryPlaceholder: 'Sélectionner le pays',
        domainLabel: 'Site Web de l’école',
        domainPlaceholder: 'www.mon_universite.ca',
        orgNameLabel: 'Nom de l’école',
        orgNamePlaceholder: 'Mon école',
    },
    step: {
        success: {
            title: 'Merci d’avoir soumis votre demande d’école !',
            description: 'À titre de rappel, chaque demande est évaluée par SheerID par rapport aux exigences fixées par cette offre. Il n\'y a aucune garantie que votre école sera ajoutée. Le processus d\'évaluation prendra jusqu\'à 7 jours.',
        },
        error: {
            title: 'Une erreur inattendue est survenue',
            description: 'Désolé, nous ne sommes pas en mesure de traiter votre demande. Veuillez réessayer plus tard.',
            seeingProblem: 'Si ce problème persiste,',
            contactUs: 'contactez-nous',
        },
    },
    errorId: {
        invalidCountry: 'Le champ est requis',
        invalidEmail: 'Adresse courriel invalide',
        invalidFirstName: 'Prénom invalide',
        invalidLastName: 'Nom invalide',
        requiredField: 'Le champ est requis',
        invalidField: 'Le champ est invalide',
        invalidUrl: 'Adresse URL invalide',
        tooManyResults: 'Votre recherche a produit trop de résultats. Veuillez affiner votre recherche et réessayer.',
    },
    faq: 'Questions fréquentes sur la Demande d\'ajout d\'une école de SheerID',
    countries: {
        AD: 'Andorre',
        AE: 'Émirats Arabes Unis',
        AF: 'Afghanistan',
        AG: 'Antigua-et-Barbuda',
        AI: 'Anguilla',
        AL: 'Albanie',
        AM: 'Arménie',
        AN: 'Antilles néerlandaises',
        AO: 'Angola',
        AR: 'Argentine',
        AS: 'Samoa américaines',
        AT: 'Autriche',
        AU: 'Australie',
        AW: 'Aruba',
        AZ: 'Azerbaïdjan',
        BA: 'Bosnie-Herzégovine',
        BB: 'Barbade',
        BD: 'Bangladesh',
        BE: 'Belgique',
        BF: 'Burkina Faso',
        BG: 'Bulgarie',
        BH: 'Bahreïn',
        BI: 'Burundi',
        BJ: 'Bénin',
        BM: 'Bermudes',
        BN: 'Brunéi Darussalam',
        BO: 'Bolivie',
        BR: 'Brésil',
        BS: 'Bahamas',
        BT: 'Bhoutan',
        BV: 'Île Bouvet',
        BW: 'Botswana',
        BY: 'Biélorussie',
        BZ: 'Belize',
        CA: 'Canada',
        CD: 'République démocratique du Congo',
        CF: 'République centrafricaine',
        CG: 'Congo',
        CH: 'Suisse',
        CI: 'Côte d\'Ivoire (Côte d\'Ivoire)',
        CK: 'les Îles Cook',
        CL: 'Chili',
        CM: 'Cameroun',
        CN: 'Chine',
        CO: 'Colombie',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cap-Vert',
        CY: 'Chypre',
        CZ: 'République Tchèque ',
        DE: 'Allemagne',
        DJ: 'Djibouti',
        DK: 'Danemark',
        DM: 'Dominique',
        DO: 'République Dominicaine',
        DZ: 'Algérie',
        EC: 'Équateur ',
        EE: 'Estonie',
        EG: 'Égypte ',
        EH: 'Sahara occidental',
        ER: 'Érythrée ',
        ES: 'Espagne',
        ET: 'Éthiopie ',
        FI: 'Finlande',
        FJ: 'Fidji',
        FK: 'les îles Falkland',
        FM: 'Micronésie',
        FO: 'Îles Féroé',
        FR: 'France',
        GA: 'Gabon',
        GB: 'Royaume-Uni',
        GD: 'Grenade',
        GE: 'Géorgie',
        GF: 'Guyane française',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Groenland',
        GM: 'Gambie',
        GN: 'Guinée',
        GP: 'Guadeloupe (français)',
        GQ: 'Guinée Équatoriale',
        GR: 'Grèce',
        GS: 'Géorgie du Sud et îles Sandwich du Sud',
        GT: 'Guatemala',
        GU: 'Guam (États-Unis)',
        GW: 'Guinée Bissau',
        GY: 'Guyane',
        HK: 'Hong Kong',
        HM: 'Îles Heard et McDonald',
        HN: 'Honduras',
        HR: 'Croatie',
        HT: 'Haïti',
        HU: 'Hongrie',
        ID: 'Indonésie',
        IE: 'Irlande',
        IL: 'Israël',
        IN: 'Inde',
        IO: 'Territoire britannique de l\'océan Indien',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Islande',
        IT: 'Italie',
        JM: 'Jamaïque',
        JO: 'Jordanie',
        JP: 'Japon',
        KE: 'Kenya',
        KG: 'Kirghizistan',
        KH: 'Cambodge',
        KI: 'Kiribati',
        KM: 'Comores',
        KN: 'Saint-Christophe-et-Niévès-Anguilla',
        KP: 'Corée du Nord',
        KR: 'Corée du Sud',
        KW: 'Koweït',
        KY: 'Îles Caïmans',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Liban',
        LC: 'Sainte-Lucie',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Libéria',
        LS: 'Lesotho',
        LT: 'Lituanie',
        LU: 'Luxembourg',
        LV: 'Lettonie',
        LY: 'Libye',
        MA: 'Maroc',
        MC: 'Monaco',
        MD: 'Moldavie',
        ME: 'Monténégro',
        MG: 'Madagascar',
        MH: 'Îles Marshall',
        MK: 'Macédoine',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolie',
        MO: 'Macao',
        MP: 'Îles Mariannes du Nord',
        MQ: 'Martinique (français)',
        MR: 'Mauritanie',
        MS: 'Montserrat',
        MT: 'Malte',
        MU: 'Maurice',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexique',
        MY: 'Malaisie',
        MZ: 'Mozambique',
        NA: 'Namibie',
        NC: 'Nouvelle-Calédonie (français)',
        NE: 'Niger',
        NF: 'Île Norfolk',
        NG: 'Nigéria',
        NI: 'Nicaragua',
        NL: 'Pays-Bas',
        NO: 'Norvège',
        NP: 'Népal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nouvelle-Zélande',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Pérou',
        PF: 'Polynésie (française)',
        PG: 'Papouasie Nouvelle Guinée ',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Pologne',
        PM: 'Saint-Pierre-et-Miquelon',
        PN: 'Île Pitcairn',
        PR: 'Porto Rico',
        PS: 'Palestine',
        PT: 'le Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Réunion (français)',
        RO: 'Roumanie',
        RS: 'Serbie',
        RU: 'Fédération Russe',
        RW: 'Rwanda',
        SA: 'Arabie Saoudite',
        SB: 'Les îles Salomon',
        SC: 'les Seychelles',
        SD: 'Soudan',
        SE: 'Suède',
        SG: 'Singapour',
        SH: 'Sainte-Hélène',
        SI: 'Slovénie',
        SK: 'République slovaque',
        SL: 'Sierra Leone',
        SM: 'Saint Marin',
        SN: 'Sénégal',
        SO: 'Somalie',
        SR: 'Suriname',
        SS: 'Soudan du Sud',
        ST: 'São Tomé-et-Principe ou Saint-Thomas-et-l\'île du Prince',
        SV: 'Le Salvador',
        SY: 'Syrie',
        SZ: 'Swaziland',
        TC: 'îles Turques-et-Caïques',
        TD: 'Tchad',
        TF: 'Territoires français du Sud',
        TG: 'Togo',
        TH: 'Thaïlande',
        TJ: 'Tadjikistan',
        TK: 'Tokelau',
        TL: 'Timor oriental',
        TM: 'Turkménistan',
        TN: 'Tunisie',
        TO: 'Tonga',
        TR: 'Turquie',
        TT: 'Trinité-et-Tobago',
        TV: 'Tuvalu',
        TW: 'Taïwan',
        TZ: 'Tanzanie',
        UA: 'Ukraine',
        UG: 'Ouganda',
        UM: 'Îles mineures éloignées des États-Unis',
        US: 'États-Unis',
        UY: 'Uruguay',
        UZ: 'Ouzbékistan',
        VA: 'État de la Cité du Vatican',
        VC: 'Saint Vincent et Grenadines',
        VE: 'Venezuela',
        VG: 'Îles Vierges (Britanniques)',
        VI: 'Îles Vierges (États-Unis)',
        VN: 'Viêt Nam',
        VU: 'Vanuatu',
        WF: 'Îles Wallis et Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yémen',
        YT: 'Mayotte',
        ZA: 'Afrique du Sud',
        ZM: 'Zambie',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'arabe',
        bg: 'bulgare',
        cs: 'tchèque',
        da: 'danois',
        de: 'allemand',
        el: 'grec',
        'en-GB': 'Anglais Royaume-Uni)',
        'en-US': 'Anglais',
        'es-ES': 'Espagnol (Espagne)',
        es: 'Espagnol',
        fi: 'finlandais ',
        'fr-CA': 'Français (canadien)',
        fr: 'français',
        hr: 'croate',
        hu: 'hongrois',
        id: 'indonésien',
        is: 'islandais',
        it: 'italien',
        iw: 'hébreu',
        ja: 'Japonais',
        ko: 'coréen',
        lt: 'lituanien',
        ms: 'malais',
        nl: 'néerlandais',
        no: 'norvégien',
        pl: 'polonais',
        'pt-BR': 'Portugais (Brésil)',
        pt: 'Portugais',
        ro: 'roumain',
        ru: 'Russie',
        sk: 'slovaque',
        sl: 'slovène',
        sr: 'serbe',
        sv: 'suédois',
        tr: 'turc',
        'zh-HK': 'Chinois (Hong Kong)',
        zh: 'Chinois (Traditionnel)',
    },
};
